import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsOptional } from "class-validator";

export class GetStoreConsumptionRequest {
    @ApiProperty()
    @IsOptional()
    storeConsumptionId: number;

    /**
     * 
     * @param storeConsumptionId 
     */
    constructor(storeConsumptionId?: number){
        this.storeConsumptionId = storeConsumptionId; 
    }
}